import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GraphDialogComponent } from '../components/dialogs/graph-dialog/graph-dialog.component';
import { GraphItem } from '../interfaces/GraphItem';
import { MetricType } from '../interfaces/MetricType';

@Injectable({
  providedIn: 'root'
})
export class GraphDialogService {

  constructor() { }

  dialog = inject(MatDialog);

  openDialog(metricsTypes: MetricType[], getDataFunction: Function) {
    const dialogRef = this.dialog.open(GraphDialogComponent, {
      data: { metricsTypes, getDataFunction },
      panelClass: 'full-dialog',
    });
    return dialogRef.afterClosed();
  }

  closeDialog() {
    return this.dialog.closeAll();
  }
}
